import React from 'react'
import { Grid, PageSection as Section, Heading, Body } from '@superhi/design'

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 5,
}
const GRID_1_CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: [7, 12],
}

const Intro: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Section collapseBottomPadding decorationName="star" decorationPosition="bottom-left">
    <Grid>
      <Grid.Cell span={GRID_1_CELL_SPAN_1}>
        <Heading level="3" as="h2">
          At SuperHi, we do more than teach people how to code. We create products and tools that
          rethink how people code.
        </Heading>
      </Grid.Cell>

      <Grid.Cell span={GRID_1_CELL_SPAN_2}>
        <Body level="2">
          The SuperHi Editor is a code editor that hosts all your files in one place and publishes
          your sites to the web with the click of a button.
        </Body>

        <Body level="2">
          Designed with beginners in mind, it helps you learn and get started making websites right
          away, without worrying about all the technical stuff like hosting. Get quick tips like
          spellcheck and color selection while you type. Any questions? Ask Wilson, our AI-powered
          assistant, and get answers right in the editor.
        </Body>
      </Grid.Cell>
    </Grid>
  </Section>
)

export default Intro
